import React, { Component } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import getData from './../data-services/api';
import { withRouter } from 'react-router-dom';
import './ImageSlider.css';

class ImageSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            carouselData: [],
            workshops: [],
            userData: {},
        };
    }

    async componentDidMount() {
        Promise.all([
            getData(
                `Select id, Name, Sequence__c, Url__c, systemmodstamp from salesforce.News_Dashboard__c where Active__c = true ORDER BY Sequence__c ASC`
            ),
        ]).then(([carouselData, ...data]) => {
            const slides = (carouselData.result || [])
                .slice()
                .sort((a, b) => Number(a.sequence__c || 0) - Number(b.sequence__c || 0));
            this.setState({
                carouselData: slides,
                loading: false,
            });
        });
    }

    render() {
        const { carouselData } = this.state;
        return (
            <>
                {carouselData.length > 0 && (
                    <Carousel infiniteLoop autoPlay showThumbs={false} interval={3000}>
                        {carouselData.map((item) => (
                            <div key={item.id}>
                                <img src={item.url__c} alt="img" />
                            </div>
                        ))}
                    </Carousel>
                )}
            </>
        );
    }
}

export default withRouter(ImageSlider);
